// import { isSandbox } from 'std/url';

const URL_PROD = "https://api.tecno.mobi";
// const URL_SAND = 'https://sandbox.tecno.mobi';

// const url = isSandbox() ? URL_SAND : URL_PROD;
const url = URL_PROD;
export const baseUrlMercurio = `${url}/api/v1`;
